(function () {
  function init(root) {
    if (root.dataset.sfcReady) return;
    root.dataset.sfcReady = '1';
    var track = root.querySelector('[data-sfc-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-sfc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sfc-dot]'));
    var prev = root.querySelector('[data-sfc-prev]');
    var next = root.querySelector('[data-sfc-next]');
    var status = root.querySelector('[data-sfc-status]');
    var current = -1;

    function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
    function index() { return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (step() || 1)))); }
    function maxScroll() { return track.scrollWidth - track.clientWidth - 2; }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    function update() {
      var i = index();
      if (track.scrollLeft >= maxScroll() && maxScroll() > 0) i = slides.length - 1;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll();
      if (i === current) return;
      current = i;
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (status) status.textContent = 'Card ' + (i + 1) + ' of ' + slides.length;
    }

    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.dataset.sfcDot, 10)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
    });
    update();
  }
  function boot() { document.querySelectorAll('.sfc').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-sfc-slide]');
    if (slide) slide.parentNode.scrollTo({ left: slide.offsetLeft - slide.parentNode.firstElementChild.offsetLeft, behavior: 'smooth' });
  });
})();
